<template>
  <v-dialog
    v-model="dialog"
    v-if="bird"
    max-width="800px"
    :width="$vuetify.breakpoint.name == 'xs' ? '95%' : '60%'"
    style="z-index: 9999"
  >
    <v-card class="card" style="z-index: 9999">
      <button @click="$emit('close')" class="close-btn">
        <v-icon>mdi-close</v-icon>
      </button>
      <v-card-title>
        <div>
          <h1>{{ bird.name }}</h1>
          <h2>{{ bird.nameLatin }}</h2>
        </div>
      </v-card-title>
      <v-card-text>
        <v-row class="mt-3">
          <v-col cols="12" md="5">
            <div align="center" class="left-side">
              <img
                :src="'bird-pics/' + bird.url + '.png'"
                alt="bird"
                class="bird-pic"
              />
              <v-btn
                rounded
                icon
                text
                :disabled="freezePlayBtn"
                class="play-btn"
                @click="playSound(bird.url)"
              >
                <img src="../assets/play.svg" style="width: 105px" alt="play" />
              </v-btn>
            </div>
          </v-col>
          <v-col>
            <div
              class="mt-10 mb-5"
              v-for="(tipp, index) in bird.tipps"
              :key="index"
              style="
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                justify-content: flex-start;
              "
            >
              <div
                style="width: 25px; float: left; align-items: center"
                class="mr-5"
              >
                <img
                  :src="
                    require('../assets/icons/' + Object.keys(tipp)[0] + '.svg')
                  "
                  alt="point"
                  style="height: 24px; margin: auto"
                />
              </div>
              <div style="text-align: center">
                <p style="margin: auto">
                  {{ Object.values(tipp)[0] }}
                </p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BirdCard",
  props: { dialog: Boolean, bird: Object, players: Object, musicOn: Boolean },
  data() {
    return { freezePlayBtn: false };
  },
  methods: {
    playSound(name) {
      let wasMuted;
      this.freezePlayBtn = true;
      this.musicOn ? (wasMuted = false) : (wasMuted = true);
      wasMuted ? null : this.$emit("toggle-music");
      this.players.player(name).start();
      setTimeout(() => {
        wasMuted ? null : this.$emit("toggle-music");
        this.freezePlayBtn = false;
      }, 7000);
    },
  },
};
</script>

<style scoped>
.card {
  color: white;
  border-radius: 30px;
  padding: 20px;
  min-height: 450px;
  border-radius: 20px !important;
}
.close-btn {
  position: absolute;
  right: 5%;
  top: 5%;
}
.bird-pic {
  width: 100%;
  border-radius: 20px;
  margin-bottom: 10px;
}
h1,
h2 {
  text-align: left;
  font-style: normal;
  font-weight: bold;
  font-size: calc(15px + 2vw);
  line-height: 43px;
  display: flex;
  align-items: flex-end;
  letter-spacing: 0.05em;
  color: #000000;
  font-family: "MabryMedium";
}
h2 {
  font-weight: normal;
  font-style: italic;
  font-family: "MabryItalic";
}
p {
  font-style: normal;
  font-weight: normal;
  font-family: "MabryMedium";
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.05em;
  color: #000000;
  margin: auto;
  margin-left: 40px;
  text-align: left;
  width: 100%;
}
.v-row {
  margin-top: 20px;
}
.play-btn {
  margin-bottom: 10px;
  width: 100%;
  height: 115px !important;
}
.left-side {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
</style>